import React, { useContext, useEffect } from "react";
import SessionExpiredContext from "../../context/SessionExpiredContext";
import { useLocation } from "react-router-dom";

const SessionCountdown = () => {
  const { remainingTime, refreshToken, isTokenExpiringSoon } = useContext(SessionExpiredContext);
  const location = useLocation();

  // Effect to detect navigation with better debugging
  useEffect(() => {
    if (refreshToken && isTokenExpiringSoon()) {
      refreshToken();
    }
  }, [location.pathname, refreshToken, isTokenExpiringSoon]);

  // Format the remaining time into MM:SS
  const formatTime = (seconds) => {
    if (seconds === null) return "--:--";

    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return [
      minutes.toString().padStart(2, "0"),
      secs.toString().padStart(2, "0"),
    ].join(":");
  };

  // Determine color based on time remaining
  const getColorClass = () => {
    if (remainingTime === null) return "";
    if (remainingTime < 300) return "session-countdown-critical"; // less than 5 minutes
    if (remainingTime < 900) return "session-countdown-warning"; // less than 15 minutes
    return "session-countdown-normal";
  };

    // Only show countdown if less than 15 minutes remaining
    if (remainingTime === null || remainingTime >= 900) {
        return null; // Don't render anything if more than 15 minutes left
      }

  return (
    <div className="session-countdown">
      <span
        className={`session-time ${getColorClass()}`}
        title="Hátralevő munkamenet idő"
      >
        {formatTime(remainingTime)}
      </span>
    </div>
  );
};

export default SessionCountdown;
